import { dedupePromise } from '~/shared/utils/dedupePromise';
import { EmployeeRole } from '~/modules/employees/enums/EmployeeRole';
import { fetchCurrentEmployee } from '~/modules/employees/api/employees.api';
import type { CurrentEmployeeDto } from '~/modules/employees/api/dto/employees.dto';
import { ApiException } from '~/shared/errors/ApiException';

/**
 * Профиль служит признаком авторизации для всего приложения, поэтому стор
 * не зависит от auth.store, а наоборот: обратная связь замкнула бы цикл.
 */
export const useCurrentEmployeeStore = defineStore('current-employee', () => {
  const currentEmployee = ref<CurrentEmployeeDto | undefined>();

  const hasSupervisorRole = computed(() => currentEmployee.value?.role === EmployeeRole.supervisor);

  const loadEmployee = dedupePromise(async () => {
    try {
      currentEmployee.value = await fetchCurrentEmployee();
    } catch (error) {
      if (!(error instanceof ApiException)) {
        throw error;
      }
    }
  });

  function dropEmployee() {
    currentEmployee.value = undefined;
  }

  async function initStore() {
    if (currentEmployee.value) {
      return;
    }

    // Проба сессии на старте. Глушим и сетевую ошибку тоже: она наследует
    // Error, а не ApiException, и иначе роняет плагин инициализации,
    // а вместе с ним все последующие
    try {
      await loadEmployee();
    } catch (error) {
      console.error('initStore: профиль сотрудника не загружен', error);
    }
  }

  return {
    currentEmployee,
    hasSupervisorRole,
    loadEmployee,
    dropEmployee,
    initStore,
  };
});
